module.exports = __webpack_public_path__ + "img/arrow_drop_up.65cfecc1.svg";